// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".support-bubble[data-v-17704f1e]{bottom:2.5rem;right:4rem;background-color:#a3a3a3;border-radius:10rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
